import dynamic from 'next/dynamic';

import { HotelGalleryPhotoViewerComponentProps } from './HotelGalleryPhotoViewer.types';

export const HotelGalleryPhotoViewer = dynamic<HotelGalleryPhotoViewerComponentProps>(() =>
  import('./HotelGalleryPhotoViewerComponent').then(module => module.HotelGalleryPhotoViewerComponent)
);
